export const bendingTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_authorised' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },
]
